import { useState } from "react";
import { FaChevronDown } from "react-icons/fa";

const faqData = [
    {
      question: "What are the best blinds for privacy?",
      answer: "Blackout roller shades or cellular shades offer excellent privacy, blocking outside views completely.",
    },
    {
      question: "Are blinds better than curtains for energy efficiency?",
      answer: "Cellular shades are better for insulation, reducing heat loss in winter and keeping rooms cool in summer.",
    },
    {
      question: "How do I clean my window blinds?",
      answer: "Dust regularly with a microfiber cloth or vacuum with a brush attachment. For deeper cleaning, use a damp cloth with mild soap.",
    },
    {
      question: "Are motorized blinds worth it?",
      answer: "Yes! Motorized blinds offer convenience, smart home integration, and enhanced security while you're away.",
    },
    {
      question: "What are the most durable blinds for high-traffic areas?",
      answer: "Faux wood blinds and aluminum blinds are durable, moisture-resistant, and ideal for high-traffic areas.",
    },
    {
      question: "Can blinds and shades help reduce noise?",
      answer: "Yes! Cellular shades with double or triple layers can absorb sound and reduce outside noise.",
    },
    {
      question: "What are the best window coverings for large windows?",
      answer: "Vertical blinds, panel track blinds, and motorized roller shades work well for large windows and sliding doors.",
    },
    {
      question: "Are there child-safe blinds available?",
      answer: "Yes! Cordless blinds, motorized shades, and roller shades are safer alternatives for homes with children or pets.",
    },
    {
      question: "What is the difference between inside and outside mount blinds?",
      answer: "Inside mount fits within the window frame for a sleek look, while outside mount covers the entire window for better light control.",
    },
    {
      question: "Do blackout blinds completely block sunlight?",
      answer: "Blackout blinds significantly reduce light, but small gaps around the edges may let in minimal light unless side channels are used.",
    },
  ];
  

const FaqComponent = () => {
  const [openIndex, setOpenIndex] = useState(null);

  const toggleFaq = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <div className="max-w-7xl mx-auto p-6">
      <h2 className="text-2xl xl:text-4xl font-bold text-gray-800 text-center mb-6">FAQs - Blinds & Shades</h2>
      <div className="space-y-4">
        {faqData.map((faq, index) => (
          <div key={index} className="border border-gray-200 rounded-lg shadow-sm xl:text-2xl ">
            <button
              className="flex justify-between items-center w-full p-6 text-left font-medium text-gray-700 bg-gray-100 hover:bg-gray-200 transition"
              onClick={() => toggleFaq(index)}
            >
              {faq.question}
              <FaChevronDown
                className={`text-gray-500 text-lg transition-transform ${
                  openIndex === index ? "rotate-180" : ""
                }`}
              />
            </button>
            {openIndex === index && (
              <div className="p-8 text-gray-600 xl:text-xl  border-t border-gray-200 bg-white">
                {faq.answer}
              </div>
            )}
          </div>
        ))}
      </div>
    </div>
  );
};

export default FaqComponent;
